import { render, staticRenderFns } from "./MarketplacePaymentTerm.vue?vue&type=template&id=41029408&scoped=true&"
import script from "./MarketplacePaymentTerm.vue?vue&type=script&lang=js&"
export * from "./MarketplacePaymentTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41029408",
  null
  
)

export default component.exports